import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class AccessRole {
    @observable id!: number;

    @observable tag!: string;

    @observable rank!: number;

    @observable description!: string;

    constructor(role?: ModelProperties<AccessRole>) {
        if (role) {
            construct(this, role);
        }
    }
}